(() => {
  if (!customElements.get('kovali-halloween-copy')) {
    customElements.define('kovali-halloween-copy', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-kh-copy]');
        if (!this.button || this.onCopy) return;
        this.onCopy = async () => {
          const code = 'HERBST26';
          let copied = false;
          try {
            if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(code);
              copied = true;
            }
          } catch (_) { /* Use the selection-based fallback below. */ }
          if (!copied) {
            const input = document.createElement('textarea');
            input.value = code;
            input.setAttribute('readonly', '');
            input.setAttribute('aria-label', 'Rabattcode');
            input.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0;font-size:16px;';
            document.body.appendChild(input);
            input.select();
            input.setSelectionRange(0, code.length);
            try { copied = document.execCommand('copy'); } catch (_) { /* Manual selection follows. */ }
            input.remove();
            this.button.focus({ preventScroll: true });
          }
          if (!this.isConnected) return;
          const status = this.querySelector('[data-kh-status]');
          clearTimeout(this.feedbackTimer);
          if (copied) {
            this.setAttribute('data-kh-copied', '');
            if (status) status.textContent = 'Code HERBST26 kopiert.';
            this.button.title = 'Code kopiert!';
            this.feedbackTimer = setTimeout(() => {
              this.removeAttribute('data-kh-copied');
              if (status) status.textContent = '';
              this.button.title = 'Antippen und Code kopieren';
            }, 2400);
          } else {
            this.removeAttribute('data-kh-copied');
            const text = this.querySelector('[data-kh-code]');
            const selection = window.getSelection();
            if (text && selection) {
              const range = document.createRange();
              range.selectNodeContents(text);
              selection.removeAllRanges();
              selection.addRange(range);
            }
            this.button.title = 'Code HERBST26 bitte manuell kopieren';
            if (status) status.textContent = 'Bitte den markierten Code HERBST26 manuell kopieren.';
          }
        };
        this.button.addEventListener('click', this.onCopy);
      }
      disconnectedCallback() {
        if (this.button && this.onCopy) this.button.removeEventListener('click', this.onCopy);
        this.onCopy = null;
        clearTimeout(this.feedbackTimer);
      }
    });
  }

  if (!customElements.get('kovali-halloween-countdown')) {
    customElements.define('kovali-halloween-countdown', class extends HTMLElement {
      connectedCallback() {
        if (this.timer) return;
        // Same starting duration as the existing, disabled KOVALI special banner.
        this.endTime = Date.now() + Number(this.dataset.duration || 8246) * 1000;
        const update = () => {
          const remaining = Math.max(0, Math.ceil((this.endTime - Date.now()) / 1000));
          const pad = value => String(value).padStart(2, '0');
          this.textContent = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60].map(pad).join(':');
          if (remaining === 0) {
            clearInterval(this.timer);
            this.timer = null;
          }
        };
        this.timer = setInterval(update, 1000);
        update();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.timer = null;
      }
    });
  }
})();
